export function AIHistoryTableSkeleton() {
  return (
    <div className="rounded-xl border border-slate-200/50 bg-white overflow-hidden shadow-sm">
      <table className="w-full">
        <thead>
          <tr className="border-b border-slate-100">
            <th className="px-4 py-3 bg-slate-50/50 w-[100px]">
              <div className="h-3 w-16 bg-slate-200 rounded animate-pulse" />
            </th>
            <th className="px-4 py-3 bg-slate-50/50">
              <div className="h-3 w-24 bg-slate-200 rounded animate-pulse" />
            </th>
            <th className="px-4 py-3 bg-slate-50/50 w-[140px]">
              <div className="h-3 w-12 bg-slate-200 rounded animate-pulse" />
            </th>
            <th className="px-4 py-3 bg-slate-50/50 w-[80px]">
              <div className="h-3 w-10 bg-slate-200 rounded animate-pulse" />
            </th>
            <th className="px-4 py-3 bg-slate-50/50 w-[100px]">
              <div className="h-3 w-12 bg-slate-200 rounded animate-pulse" />
            </th>
            <th className="px-4 py-3 bg-slate-50/50 w-[100px]" />
          </tr>
        </thead>
        <tbody>
          {[...Array(6)].map((_, i) => (
            <tr key={i} className="border-b border-slate-100 last:border-b-0">
              <td className="px-4 py-4">
                <div className="h-6 w-20 bg-slate-100 rounded-full animate-pulse" />
              </td>
              <td className="px-4 py-4">
                <div className="flex items-center gap-3">
                  <div className="h-8 w-8 bg-slate-100 rounded-lg animate-pulse" />
                  <div className="space-y-2">
                    <div className="h-4 w-32 bg-slate-100 rounded animate-pulse" />
                    <div className="h-3 w-20 bg-slate-100 rounded animate-pulse" />
                  </div>
                </div>
              </td>
              <td className="px-4 py-4">
                <div className="h-4 w-24 bg-slate-100 rounded animate-pulse" />
              </td>
              <td className="px-4 py-4">
                <div className="h-4 w-10 bg-slate-100 rounded animate-pulse" />
              </td>
              <td className="px-4 py-4">
                <div className="h-4 w-16 bg-slate-100 rounded animate-pulse" />
              </td>
              <td className="px-4 py-4">
                <div className="h-6 w-16 bg-slate-100 rounded animate-pulse ml-auto" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default AIHistoryTableSkeleton
